export default function IconStar({ isGray }: { isGray?: boolean }) {
  return (
    <>
      {isGray ? (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.99609 2.345L9.61609 5.5L9.84109 5.94L10.3411 6.035L13.8411 6.68L11.3411 9.375L11.0211 9.715L11.0811 10.18L11.5811 13.82L8.48109 12.25L7.99609 12.025L7.53609 12.26L4.43609 13.83L4.93609 10.19L4.99609 9.725L4.67609 9.385L2.17609 6.69L5.67609 6.045L6.17609 5.95L6.40109 5.51L7.99609 2.345M7.99609 1C7.72109 1 7.45109 1.205 7.24109 1.61L5.49609 5.06L1.85609 5.73C0.956088 5.9 0.726088 6.585 1.35609 7.26L3.93609 10.06L3.43609 13.95C3.35109 14.61 3.63109 15 4.10609 15C4.31456 14.9921 4.5183 14.9356 4.70109 14.835L7.99609 13.15L11.3211 14.835C11.5039 14.9356 11.7076 14.9921 11.9161 15C12.3911 15 12.6711 14.61 12.5861 13.95L12.0861 10.06L14.6661 7.26C15.2861 6.585 15.0561 5.9 14.1661 5.73L10.4961 5.06L8.73609 1.61C8.54109 1.205 8.27109 1 7.99609 1Z"
            fill="#54545A"
          />
        </svg>
      ) : (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.99609 2.345L9.61609 5.5L9.84109 5.94L10.3411 6.035L13.8411 6.68L11.3411 9.375L11.0211 9.715L11.0811 10.18L11.5811 13.82L8.48109 12.25L7.99609 12.025L7.53609 12.26L4.43609 13.83L4.93609 10.19L4.99609 9.725L4.67609 9.385L2.17609 6.69L5.67609 6.045L6.17609 5.95L6.40109 5.51L7.99609 2.345M7.99609 1C7.72109 1 7.45109 1.205 7.24109 1.61L5.49609 5.06L1.85609 5.73C0.956088 5.9 0.726088 6.585 1.35609 7.26L3.93609 10.06L3.43609 13.95C3.35109 14.61 3.63109 15 4.10609 15C4.31456 14.9921 4.5183 14.9356 4.70109 14.835L7.99609 13.15L11.3211 14.835C11.5039 14.9356 11.7076 14.9921 11.9161 15C12.3911 15 12.6711 14.61 12.5861 13.95L12.0861 10.06L14.6661 7.26C15.2861 6.585 15.0561 5.9 14.1661 5.73L10.4961 5.06L8.73609 1.61C8.54109 1.205 8.27109 1 7.99609 1Z"
            fill="#006AFF"
          />
        </svg>
      )}
    </>
  );
}
